// The API depends on this package, so these links cannot live in the API without the email
// templates losing access to them. They live here, and the API re-exports them for the frontend.
export const WEBSITE_URL = "https://www.unbox.social";
export const TERMS_OF_SERVICE_URL = `${WEBSITE_URL}/terms-conditions`;
